/**
 * CadenceStep pure components.
 * These components receive all data as props instead of fetching via tRPC,
 * making them usable in both NextJS (with tRPC wrappers) and Electron (with IPC).
 */

export {
  CadenceStepSectionPure,
} from './CadenceStepSectionPure';

export {
  MessageAttachmentButtonPure,
  MESSAGE_ATTACHMENT_MAX_BYTES,
} from './MessageAttachmentButtonPure';

export type { MessageAttachmentState } from './MessageAttachmentButtonPure';

export type {
  CadenceStepSectionPureProps,
  CadenceStepType,
  SendMode,
  StepChanges,
  StepData,
  EditorDocument,
  EmailOption,
  ThreadOption,
  AiChoice,
  StepListItem,
  ContactForStep,
  ContactUserForStep,
  UserTeamForStep,
} from './CadenceStepSectionPure';

// Re-export ReminderAction for convenience
export type { ReminderAction } from '../ManualSelect';
